export const PRODUCT_TYPES = {
  REGULAR: "REGULAR",
  REWARD: "REWARD",
  PURCHASE: "PURCHASE",
};

export const PRODUCT_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ARCHIVED: "ARCHIVED",
};
